/**
 * Animations d'apparition — orchestration.
 *
 * Composant global (auto-chargé sur toutes les pages, comme Header/Footer).
 * Tout se pilote depuis le HTML avec l'attribut "data-reveal" (voir
 * src/sass/components/_reveal.scss pour le détail des valeurs possibles et
 * des exemples). Ce fichier se contente de :
 *   1. découper le texte si besoin (data-reveal="lines"/"words"/"chars",
 *      via TextSplitter.js) ;
 *   2. observer les éléments et ajouter "is-inview" quand ils entrent dans
 *      le viewport (l'animation elle-même est en CSS pur).
 *
 * export const observe(el) est réutilisé ailleurs (ex: LoadMore.js) pour
 * brancher les nouveaux éléments injectés après coup (chargement AJAX).
 */

import { splitLines, splitWords, splitChars } from '&/class/TextSplitter'

let observer = null
let resizeTimeout = null
const lineElements = []

function getObserver () {

  if (observer) return observer

  observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return
      entry.target.classList.add('is-inview')
      observer.unobserve(entry.target)
    })
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -5% 0px'
  })

  return observer
}

function prepare (el) {

  if (el.dataset.revealReady) return
  el.dataset.revealReady = '1'

  switch (el.dataset.reveal) {
    case 'lines':
      splitLines(el)
      lineElements.push(el)
      break
    case 'words':
      splitWords(el)
      break
    case 'chars':
      splitChars(el)
      break
    // 'fade' : aucun découpage, "is-inview" suffit (voir _reveal.scss).
  }

}

export function observe (el) {
  if (!el || !el.dataset || !el.dataset.reveal) return
  prepare(el)
  getObserver().observe(el)
}

export function render () {

  document.querySelectorAll('[data-reveal]').forEach(observe)

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout)
    resizeTimeout = setTimeout(() => {
      // Les lignes dépendent de la largeur du conteneur : on re-découpe
      // sans perdre le texte d'origine (voir splitLines).
      lineElements.forEach(el => splitLines(el))
    }, 200)
  })

}
